import React, { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import styles from './HRefWrap.module.scss';

type Props = {
    children: any;
    href: string | null | undefined;
    onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
    className?: string;
}

const HReafWrap: React.FC<Props> = ({ children, href, onClick, className }: Props) => {
    return href
        ? <Link to={href} onClick={onClick} className={`${styles.link} ${className ?? ''}`}>{children}</Link>
        : children;
}

export default HReafWrap;
